import { makeStyles } from '@mui/styles';
import Tab from 'apollo-react/components/Tab';
import Tabs from 'apollo-react/components/Tabs';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import Details from './components/Details';
import FieldsTable from './components/FieldsTable';
import Header from './components/Header';
import RelationsTable from './components/RelationsTable';
import ResolvedFieldsTable from './components/ResolvedFieldsTable';
import {
  TAB_FIELDS_INDEX,
  TAB_RELATIONS_INDEX,
  TAB_RESOLVED_FIELDS_INDEX,
} from './constants/entity-designer.constants';
import { EntityContext } from './context';
import { getIsImportMode, hasEntityUnsavedChanges } from './selectors/entity-designer.selectors';
import EntityHistoryDialog from '../components/EntityHistoryModal';
import UnsavedChangesPrompt from '../components/UnsavedChangesPrompt';
import { useTranslation } from '../custom-hooks/useTranslation';

const useStyles = makeStyles({
  root: {
    margin: '0 20px',
  },
  tablesWrapper: {
    marginTop: 20,
  },
  tabContent: {
    backgroundColor: '#fff',
    marginTop: 7,
  },
});

const EntityDesigner = ({ fieldTypes, entitiesList, entityCatalogItems, isEditMode }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const [selectedTab, setSelectedTab] = useState(TAB_FIELDS_INDEX);

  const isImportMode = useSelector(getIsImportMode);
  const hasUnsavedChanges = useSelector(hasEntityUnsavedChanges);

  const handleChangeTab = (e, value) => {
    setSelectedTab(value);
  };

  return (
    <EntityContext.Provider value={isEditMode}>
      <Header setSelectedTab={setSelectedTab} />
      <div className={classes.root}>
        <Details />
        <div className={classes.tablesWrapper}>
          <Tabs value={selectedTab} onChange={handleChangeTab} truncate>
            <Tab label={translateString('Fields')} />
            <Tab label={translateString('Entity Relations')} />
            <Tab label={translateString('Resolved Fields')} />
          </Tabs>
          <div className={classes.tabContent}>
            {selectedTab === TAB_FIELDS_INDEX && (
              <FieldsTable
                fieldTypes={fieldTypes}
                entityCatalogItems={entityCatalogItems}
                setSelectedTab={setSelectedTab}
              />
            )}
            {selectedTab === TAB_RELATIONS_INDEX && <RelationsTable entitiesList={entitiesList} />}
            {selectedTab === TAB_RESOLVED_FIELDS_INDEX && <ResolvedFieldsTable />}
          </div>
        </div>
      </div>
      <EntityHistoryDialog />
      <UnsavedChangesPrompt hasUnsavedChanges={hasUnsavedChanges || isImportMode} />
    </EntityContext.Provider>
  );
};

export default EntityDesigner;
